<template>
   <div id="contendor-principal-menus" class="container-fluid">
        <div id="encabezados">
            <h1>Busqueda de Documentos en Micrositios</h1>
            <h4>Busca archivos en alguno de los Micrositios</h4>
        </div>
        <!-- SECCION PARA LOS FILTROS DE BUSQUEDA -->
        <transition name="fade">
            <div class="seccion-filtrosDeBusqueda mt-4" >
                <div class="titulo-contendor">
                    <div class="form-inline justify-content-between">
                        <h4>Filtros de búsqueda</h4>
                    </div>
                </div>
                <FiltroBusquedaDocumento v-on:buscaFiltros="BusquedaContenidos"></FiltroBusquedaDocumento>
            </div>
        </transition>
        <!-- FIN SECCION PARA LOS FILTROS DE BUSQUEDA -->
        <!-- SECCION CRUD PARA MENUS -->
        <div id="seccion-crud" class="mt-4">
            <div class="titulo-tabla">
                <div class="row">
                    <div class="col-xs-8 col-sm-8 col-md-8 col-lg-8 pr-2 pt-1"><h4>Busqueda De Documentos en Micrositios</h4></div>
                </div>
            </div>
            <div id="tabla-documentos" class="contenedor-gris table-responsive" >

                <table 
                    class="table table-striped table-light table-hover"
                    id="tabla-documentos-encontrados"              
                    data-toggle="table"
                    data-pagination="true"
                    data-undefined-text="Sin información"                 
                    data-page-size = "5"
                    data-page-list="[5,10,20]"
                    data-click-to-select="false"
                    data-search="true"
                    >
                    <thead class="thead-dark">
                        <tr>  
                            <th data-halign="center" data-align="center" data-field="Folio" data-sortable="true">
                                Folio
                            </th>
                            <th data-halign="center" data-align="center" data-field="Estatus" data-sortable="true">
                               Estatus
                            </th>
                              <th data-halign="center"  data-align="center" data-field="Titulo" data-sortable="true">
                                Titulo
                            </th>
                            <th data-halign="center"  data-align="center" data-field="Texto" data-sortable="true">
                                Texto
                            </th>
                              <th data-halign="center"  data-align="center" data-field="Vinculo" data-sortable="true">
                                Vinculo
                            </th>
                             <th data-halign="center" data-align="center" data-field="Archivo" data-sortable="true" >
                                Documento
                            </th>
                            <th data-width="10" data-events="operateEvents" data-halign="right"  :data-formatter="this.formateaCopiarLink()" data-align="right">
                                Copiar Link
                            </th>
                            <th data-width="10" data-events="operateEvents" data-halign="right"   :data-formatter="this.formateaDescargar()" data-align="right">
                                Descargar
                            </th>
                            <th data-width="10" data-events="operateEvents" data-halign="right"  :data-formatter="this.formateaVerArchivo()" data-align="right">
                                Ver Archivo
                            </th>
                            <!-- <th data-halign="center" data-width="20" data-align="center" data-field="SubmenuAlQuePertenezco.Titulo" data-sortable="true">
                                Submenu al que pertenece
                            </th> -->
                            <!-- <th data-events="operateEvents" id="switch-contenido-activo" data-width="10" data-field="EstaActivo.html" data-halign="center" data-align="center">
                                Vinculo
                            </th>
                            <th data-events="operateEvents" data-width="15"  data-halign="center" data-align="center">
                                Archivo
                            </th> -->
                        </tr>
                    </thead>
                </table>
               
            </div>



  

</div>
    </div>
</template>
<script>
import FiltroBusquedaDocumento from '@/components/SICPO/Micrositios/BusquedaDeDocumentosMicrositios/CFiltrosDocumentosMicrositios.vue'
import comun from '@/../static/js/comun'
import axios from 'axios'
import api from '@/../static/js/api'

export default {
    data(){
        return{
            documentos:[],
            SERVIDOR_LOCAL:"\\\\themisfs",
            SERVIDOR_ARCHIVOS:"http://187.189.38.201:85",
            RUTA_VISOR: '/Ver/url?file=',
            TIPO_ARCHIVO:".pdf"
        }
    },
    components:{
        FiltroBusquedaDocumento
    },
    methods:{
        CopiarLinkArchivo:function(row){
            var ruta=null;
              if(row.Archivo.includes(this.TIPO_ARCHIVO)){
                  ruta = this.$root.$el.baseURI.replace(this.$route.path,this.RUTA_VISOR+row.RutaReal.replace(this.SERVIDOR_ARCHIVOS,this.SERVIDOR_LOCAL)); ;
             }
              else if(row.ArchivoAdicional.includes(this.TIPO_ARCHIVO)){
                   ruta = this.$root.$el.baseURI.replace(this.$route.path,this.RUTA_VISOR+row.ArchivoAdicional.replace(this.SERVIDOR_ARCHIVOS,this.SERVIDOR_LOCAL));
              }
     if(ruta != null){      
            var aux = document.createElement("input");
            aux.setAttribute("value", encodeURI(ruta));
            document.body.appendChild(aux);
            aux.select();
            document.execCommand("copy");
            document.body.removeChild(aux);
     }else{
             comun.mensajeDeAlerta("El documento esta incorrecto", null, null);
     }
        },
        AbreElVisor: function(row) {
            let vinculo=null;
            if(row.Archivo.includes(this.TIPO_ARCHIVO)){
              
                 vinculo = row.RutaReal;
                   console.log("Archivos Abrir:::",encodeURI(vinculo.replace(this.SERVIDOR_ARCHIVOS,this.SERVIDOR_LOCAL)))
                 this.$store.dispatch('A_PaginaOficial_EstableceLaRutaParaElVisor', vinculo.replace(this.SERVIDOR_ARCHIVOS,this.SERVIDOR_LOCAL));
            }
            else if(row.ArchivoAdicional.includes(this.TIPO_ARCHIVO)){
                vinculo = row.ArchivoAdicional;
                console.log("Archivos Adicional Abrir:::",vinculo)
                this.$store.dispatch('A_PaginaOficial_EstableceLaRutaParaElVisor', vinculo.replace(this.SERVIDOR_ARCHIVOS,this.SERVIDOR_LOCAL));
            } 
      },
    DescargarArchivo: function(row) {
      if(row.Archivo.includes(this.TIPO_ARCHIVO)){
          let vinculo=null;;
            vinculo=row.RutaReal;
            vinculo =vinculo.replace(this.SERVIDOR_LOCAL,this.SERVIDOR_ARCHIVOS);
           window.open(vinculo, "_blank");
      }else if(row.ArchivoAdicional.includes(this.TIPO_ARCHIVO)){
           var vinculo =row.ArchivoAdicional.replace(this.SERVIDOR_LOCAL,this.SERVIDOR_ARCHIVOS);
           window.open(vinculo, "_blank");
      }


 },
        BusquedaContenidos:function(parametros){
           console.log("PARAMETROS::::::",parametros)
            if(this.validaconFiltro(parametros))
            this.ObtenerDocumentosMicrositios(parametros)
            else
            comun.mensajeDeAlerta("elija algun parametro", null, null);
        },
        validaconFiltro:function(parametros){
            let valido =false;
            if(parametros == undefined) return false;
            else{
                if(parametros.MicrositioId != -1 && parametros.MicrositioId !=0) valido=true;
                if(parametros.PaginaId != -1 && parametros.PaginaId !=0) valido=true;
                if(parametros.SeccionId != -1 && parametros.SeccionId !=0) valido=true;
                if(parametros.FechaFinal !=null) valido=true;
                if(parametros.FechaInicial !=null) valido=true;
                if(parametros.TextoDeBusqueda !=null && parametros.TextoDeBusqueda !="") valido=true;
            }
            return valido;

        },
        
        ObtenerDocumentosMicrositios:function(parametros){
            const SERVIDOR = api.conexion;         
           const METODO_API_AGREGAR = api.SICPO.sistema.micrositioweb.busquedadecontenido.BuscarDocumentos;
           let urlApi = SERVIDOR + METODO_API_AGREGAR;
              comun.SeEstaCargandoInformacion(true);                            
                 axios.post(urlApi,parametros,comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal)).then(respuesta => {
                     comun.SeEstaCargandoInformacion(false);
                     if (respuesta.data.SiHayError) {
                         console.log(respuesta); 
                        comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
                     } 
                     else {
                        console.log(respuesta); 
                        comun.mensajeDeAlerta(respuesta.data.Satisfactorio, null, null);
                        this.llenarTablaDeDocumentos(respuesta.data);
                     }
                 }).catch(excepcion => {
                     comun.SeEstaCargandoInformacion(false);
                     comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null);
                 });
        },

        llenarTablaDeDocumentos:function(elementos,documentoContenido){
         
          if(elementos.contenidosDeMicrositios.length!=0 && elementos.archivosDeMicrositios.length!=0){
              var archivosAuxiliares = elementos.contenidosDeMicrositios.filter(archivos =>archivos.ArchivosDeContenidoMicrositios.length >1)
              if(archivosAuxiliares!=null && archivosAuxiliares.length>0){
                  archivosAuxiliares.forEach( function(a){   
                      a.ArchivosDeContenidoMicrositios.forEach(
                          function(b){            
                                b.Titulo=a.TextoDelContenido;
                                elementos.archivosDeMicrositios.push(b);
                          }
                      )
                   });
              }
             
              this.formatoADocumentosContenido(elementos.contenidosDeMicrositios.filter(archivos =>archivos.ArchivosDeContenidoMicrositios.length <=1));
              this.formatoADocumentosArchivos(elementos.archivosDeMicrositios);
              this.documentos = elementos.contenidosDeMicrositios.concat(elementos.archivosDeMicrositios)
          }

          else if(elementos.contenidosDeMicrositios.length>0 && elementos.archivosDeMicrositios.length==0){
            this.formatoADocumentosContenido(elementos.contenidosDeMicrositios);
            this.documentos = elementos.contenidosDeMicrositios;
          }

          else if(elementos.contenidosDeMicrositios.length==0 && elementos.archivosDeMicrositios.length>0){
               this.formatoADocumentosArchivos(elementos.archivosDeMicrositios);
               this.documentos = elementos.archivosDeMicrositios;
          }
          else  this.documentos.length=0; 

           $("#tabla-documentos-encontrados").bootstrapTable({data: this.documentos });
           $("#tabla-documentos-encontrados").bootstrapTable('load', this.documentos);
        },

        BuscarArchivosDeContenido:function(cont){
            let respuesta=[];
            if(cont.TextoDelVinculo==null && cont.ArchivosDeContenidoMicrositios!=null && cont.ArchivosDeContenidoMicrositios.length!=0){
                if(cont.ArchivosDeContenidoMicrositios.length==1){
                    respuesta.ArchivoVinculo = cont.ArchivosDeContenidoMicrositios[0].TextoDescripcion;
                    if(cont.RutaDeArchivo!=null || cont.RutaDeArchivo.include(this.TIPO_ARCHIVO))
                    respuesta.Ruta= cont.ArchivosDeContenidoMicrositios[0].RutaDelArchivo;
                }
            }else{
                 respuesta.ArchivoVinculo = cont.TextoDelVinculo;
                 respuesta.Ruta= cont.RutaDeArchivo;
            }

            return respuesta

        },
        formatoADocumentosContenido:function(doc){
            const ESTATUS_ACTIVO=2;
            let documento
            documento = doc.map(c => {
                let vinculoEnArchivo=null;
                let docFormateado = c;
                docFormateado.Folio = c.ContenidoDeMicrositioId;
                docFormateado.Estatus = (c.TipoEstatusDelContenido.TipoEstatusDelContenidoId==ESTATUS_ACTIVO)?"ACTIVO":"CANCELADO";
                vinculoEnArchivo=this.BuscarArchivosDeContenido(c);
                docFormateado.Titulo = (c.TextoDelContenido!=null && c.TextoDelContenido.includes('|'))?c.TextoDelContenido.split('|')[0]:"";
                docFormateado.Texto = (c.TextoDelContenido!=null && c.TextoDelContenido.includes('|'))?c.TextoDelContenido.split('|')[1]:c.TextoDelContenido;
                docFormateado.Vinculo =vinculoEnArchivo.ArchivoVinculo;  //c.TextoDelVinculo;
                docFormateado.RutaReal=vinculoEnArchivo.Ruta;
                docFormateado.Archivo =(vinculoEnArchivo.Ruta!=null && vinculoEnArchivo.Ruta.includes('\\'))?vinculoEnArchivo.Ruta.split('\\').pop(): vinculoEnArchivo.Ruta.split('/').pop();
                docFormateado.ArchivoAdicional = "Sin Informacion";

                return docFormateado;
            });
            return documento;
        },
        formatoADocumentosArchivos:function(arch){
            if(arch==null) return false;
            const ESTATUS_ACTIVO=true;
            let documento
            documento = arch.map(c => {
                let docFormateado = c;
                let nombreArchivo=this.ValidarExtencionesPermitidas(c.NombreBase);
                docFormateado.Folio = c.ContenidoDeMicrositioId;
                docFormateado.Estatus = (c.Activo==ESTATUS_ACTIVO)?"ACTIVO":"CANCELADO";
                docFormateado.Texto = c.TextoDescripcion;
                docFormateado.Titulo = c.Titulo;
                docFormateado.Vinculo = c.TextoLink;
                docFormateado.Archivo =  (nombreArchivo.Correcto)?nombreArchivo.Archivo: this.ValidarExtencionesPermitidas(c.ArchivoAdicional).Archivo;
                 docFormateado.RutaReal=this.EsArchivoAdicional(c);
                docFormateado.ArchivoAdicional = c.ArchivoAdicional;
                docFormateado.RutaDeArchivo = c.RutaDelArchivo;
                return docFormateado;
            });
            return documento;

        },

        EsArchivoAdicional:function(arc){
            if(arc.RutaDelArchivo!=null && arc.RutaDelArchivo.includes(this.TIPO_ARCHIVO)) return arc.RutaDelArchivo
            else if(arc.ArchivoAdicional!=null && arc.ArchivoAdicional.includes(this.TIPO_ARCHIVO)) return arc.ArchivoAdicional
            else return ""

        },
        ValidarExtencionesPermitidas:function(ruta){
            let respuesta=[]
            if(ruta != null && ruta.includes(this.TIPO_ARCHIVO)) {
                if(ruta.includes('\\') || ruta.includes('/')){
                    let aux = ruta.split('\\').pop();
                    aux= aux.split('\\').pop();
                    respuesta.Archivo=aux;
                    respuesta.Correcto=true;               
                }else{
                     respuesta.Archivo=ruta;
                     respuesta.Correcto=true;
                }
             
            }
            else respuesta.Correcto=false; 
            return respuesta;


        },
    
    formateaVerArchivo: () => {
            return `
            <div>
            <button id="ver_documento" type="button" class="btn btn-sm btn-xs btn btn-outline-secondary  align-center" ><i class="fas fa-eye"></i>&nbsp;Ver</button>                     
             </div>     
                 `;
        },

          formateaDescargar: () => {
            return `
            <div>
              <button id="descarga_documento" type="button" class="btn  btn-sm btn-xs btn btn-outline-secondary  align-center"  ><i class="fas fa-file-download"></i></i>&nbsp;Descargar</button>   
            </div>     
                 `;
        },
                  formateaCopiarLink: () => {
            return `
            <div>
                      <button id="copiar_documento" type="button" class="btn btn-sm btn-xs btn btn-outline-secondary align-center " ><i class="fas fa-link"></i>&nbsp;Copiar</button>                    
              </div>
              `;
        },
    },
    mounted() {
          window.operateEvents = {
            "click #ver_documento": (e,val,row,index) => {          
                this.AbreElVisor(row)
            },
            "click #descarga_documento": (e,val,row,index) => {          
                this.DescargarArchivo(row)
            },
            "click #copiar_documento": (e,val,row,index) => { 
                 this.CopiarLinkArchivo(row);         
            },
            "click #descargar-archivo-SICPO": (e,val,row,index) => {   
            },
           'click :checkbox': (e, value, row, index) => {
        this.evtCambiarEstatusDeMenu(row);
            },
            'click .icono-ampliar-texto': (e, value, row, index) => {
            },
        };
    },
    
}
</script>



// WEBPACK FOOTER //
// src/components/SICPO/Micrositios/BusquedaDeDocumentosMicrositios/CAdministradorBusquedaDeDocumentos.vue